import { createSelector } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { TEAM_ACCOUNT_TYPES } from '../../../shared/constants/accountTypes';
import { KEY_ANON_COMMENT } from '../../../shared/constants/cookie';

const selectUser = state => state.user;

export const selectCurrentUser = createSelector(
  selectUser,
  user => user.current
);

export const selectCurrentUserCreatedAt = createSelector(
  selectCurrentUser,
  user => user.createdAt
);

export const selectCurrentUserCredits = createSelector(
  selectCurrentUser,
  user => user.num_credits
);

export const selectHasPro = createSelector(
  selectCurrentUser,
  user => user.has_pro
);
export const selectHasTrialed = createSelector(
  selectCurrentUser,
  user => user.trial_status !== null
);
export const selectUserIsLogged = createSelector(
  selectUser,
  user => user.is_logged_in_checked && user.is_logged_in
);
export const selectUserHasUsedExtension = createSelector(
  selectCurrentUser,
  user => user.has_activated_chrome_extension
);
export const selectUserHasUsedDesktop = createSelector(
  selectCurrentUser,
  user => user.has_activated_desktop_app
);

export const selectUserHasUsedIos = createSelector(
  selectCurrentUser,
  user => user.has_activated_ios_app
);

export const selectUserHasUsedAndroid = createSelector(
  selectCurrentUser,
  user => user.has_activated_android_app
);

export const selectUserHasWorkspaces = createSelector(selectCurrentUser, user =>
  TEAM_ACCOUNT_TYPES.includes(user?.account_type)
);

export const selectUserId = createSelector(selectCurrentUser, user => {
  const anonId = Cookies.get(KEY_ANON_COMMENT);

  return user.id || anonId;
});

export const selectUserVideoSettings = createSelector(
  selectCurrentUser,
  user => user.video_settings
);

export const selectDefaultFillerWordRemoval = createSelector(
  selectUserVideoSettings,
  userVideoSettings => userVideoSettings.default_filler_word_removal
);
